export default function SearchIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="-0.25 -0.25 14.5 14.5"
      strokeWidth="1.5"
    >
      <g>
        <circle
          cx="5.92"
          cy="5.92"
          r="5.42"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></circle>
        <line
          x1="13.5"
          y1="13.5"
          x2="9.75"
          y2="9.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  );
}
